import { useEffect, useState } from "react";
import ReflectionPrompt from "./ReflectionPrompt";
import { getVoiceStatus } from "../lib/voice";
import { REFLECT_SUB } from "../lib/logSavedStep";

/**
 * #1397 (D360, Martin) — the reflection entry opened from the "Added to your
 * record" pill on Plan. The SAME `ReflectionPrompt` (kit variant) the saved
 * step opens, for the finished match, and the same `POST /reflections`: nothing
 * new is written. A card of its own because the pill is ink and the form is not
 * drawn on it. Mounted only by `PlanComingUp`, which is the new-look caller
 * (D217): `ReflectionPrompt` itself is untouched.
 */
export default function AddedMatchReflection({ match, onDone }) {
  const [voiceStatus, setVoiceStatus] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getVoiceStatus().then((s) => {
      if (!cancelled) setVoiceStatus(s);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <div
      data-testid="plan-match-added-reflect"
      style={{ display: "flex", flexDirection: "column", gap: 8, padding: "var(--nw-space-card)", background: "var(--nw-surface)", border: "1px solid var(--nw-navy)", borderRadius: "var(--nw-radius-card)" }}
    >
      <div style={{ fontSize: 14, lineHeight: 1.5, color: "var(--nw-ink)" }}>
        {REFLECT_SUB}
      </div>
      <ReflectionPrompt
        key={match.id}
        match={{ match_id: match.id, opponent: match.opponent }}
        onDone={onDone}
        suppressFailureToast
        variant="kit"
        voiceStatus={voiceStatus || { available: false }}
      />
    </div>
  );
}
